import useSWR from 'swr'

import { useIntegrationAxios } from '@/modules/healthblocks/hooks/useIntegrationAxios'

import type { SWRConfiguration } from 'swr'
import type { ESignDoctor } from '../types/e-sign.types'

const CACHE_KEY = 'ESign-doctors'

function useDoctors(specialisationId?: number, swrConfig?: SWRConfiguration) {
  const axios = useIntegrationAxios()

  const dynamicCacheKey = `${CACHE_KEY}${specialisationId ? '-' + specialisationId : ''}`

  const getDoctors = () => {
    return axios
      .get<ESignDoctor[]>('/e-sign/doctor', {
        cache: false,
        params: {
          specialisationId,
        },
      })
      .then((value) => {
        // Sort alphabetically
        return value.data.sort((a, b) => a.name.localeCompare(b.name))
      })
  }

  return useSWR(dynamicCacheKey, getDoctors, swrConfig)
}

export { useDoctors }
